import {
  ThematicPackageBudgetTierResponse,
  ThematicPackageCustomBudgetResponse,
} from '@features/campaigns/shared/types/campaignSubmit.ts';
import { BudgetTier } from '@features/campaigns/thematicPackage/types/thematicPackage.types.ts';
import { isKnownBudgetTier } from '@features/campaigns/thematicPackage/utils/isKnownBudgetTier.ts';

export function buildBudgetTierCards(
  budgetTiers: ThematicPackageBudgetTierResponse[],
  customBudget?: ThematicPackageCustomBudgetResponse,
): BudgetTier[] {
  const presetCards: BudgetTier[] = budgetTiers
    .filter(isKnownBudgetTier)
    .map(({ id, amount }) => ({ id, amount, isSelectable: true }));

  return [...presetCards, { id: null, amount: null, isSelectable: Boolean(customBudget?.isAvailable) }];
}
